// Reproductions fidèles (HTML/CSS) des écrans réels du produit, pour les cadres navigateur.
import { Sparkles, Radar, Layers, ExternalLink, PenLine, Image as ImageIcon, Calendar, Check, Linkedin } from "lucide-react";

const Pill = ({ children }) => (
  <span className="text-[10px] font-semibold text-coral-dark bg-coral-soft px-2 py-0.5 rounded-full">{children}</span>
);

export function GeneratorMock() {
  const props = [
    "Hier, un client m'a dit : « l'IA va remplacer mes équipes. » Faux. Elle les libère des tâches ingrates. Voici comment nous avons gagné 6h/semaine…",
    "On surestime ce qu'on fait en 1 an et on sous-estime ce qu'on fait en 3. Le vrai levier n'est pas la vitesse. C'est la constance.",
    "Arrêtez de chercher l'outil parfait. Commencez avec UN cas d'usage, mesurez, itérez. La perfection est l'ennemie de l'envoi.",
  ];
  return (
    <div className="p-5">
      <div className="flex items-center gap-2 mb-3 text-coral-dark"><Sparkles className="h-4 w-4" /><span className="text-xs font-semibold uppercase tracking-widest">Générateur</span></div>
      <div className="text-sm font-semibold text-ink mb-3">3 propositions dans votre style</div>
      <div className="space-y-2.5">
        {props.map((t, i) => (
          <div key={i} className="rounded-xl border border-slate-200 bg-white p-3.5">
            <div className="flex items-center justify-between mb-1.5">
              <span className="text-[11px] font-bold text-slate-400">Proposition {i + 1}</span>
              <div className="flex gap-1.5"><Pill>Visuel</Pill><Pill>Planifier</Pill></div>
            </div>
            <p className="text-[12.5px] leading-relaxed text-slate-700">{t}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export function VeilleMock() {
  const angles = [
    { t: "L'IA au service des équipes, pas contre elles", p: "Adoption de l'IA", s: "Blog du Modérateur" },
    { t: "La constance bat le talent : votre routine de dirigeant", p: "Leadership", s: "TEDx" },
    { t: "3 automatisations qui font gagner 6h par semaine", p: "Productivité", s: "Les Échos" },
  ];
  return (
    <div className="p-5">
      <div className="flex items-center gap-2 mb-3 text-coral-dark"><Radar className="h-4 w-4" /><span className="text-xs font-semibold uppercase tracking-widest">Veille & idées</span></div>
      <div className="text-sm font-semibold text-ink mb-3">Vos angles du lundi</div>
      <div className="space-y-2.5">
        {angles.map((a, i) => (
          <div key={i} className="rounded-xl border border-slate-200 bg-white p-3.5">
            <div className="flex items-start justify-between gap-2 mb-1"><span className="text-[13px] font-semibold text-ink leading-snug">{a.t}</span><Pill>{a.p}</Pill></div>
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-1 text-[11px] text-slate-400"><ExternalLink className="h-3 w-3" />{a.s}</span>
              <span className="flex items-center gap-1 text-[11px] font-semibold text-white bg-coral-strong px-2.5 py-1 rounded-md"><PenLine className="h-3 w-3" /> Rédiger</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function StudioMock() {
  return (
    <div className="p-5">
      <div className="flex items-center gap-2 mb-3 text-coral-dark"><ImageIcon className="h-4 w-4" /><span className="text-xs font-semibold uppercase tracking-widest">Studio de marque</span></div>
      <div className="rounded-xl overflow-hidden border border-slate-200">
        <div className="aspect-[16/9] relative flex flex-col justify-between p-5" style={{ background: "linear-gradient(135deg,#2B2B2B 0%,#3a3a3a 100%)" }}>
          <div className="absolute top-0 right-0 h-full w-2 bg-coral-strong" />
          <span className="text-[10px] font-bold uppercase tracking-widest text-white/60">Gilles Martin</span>
          <p className="font-serif text-white text-lg leading-snug max-w-[80%]">« La constance bat le talent. »</p>
          <div className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-coral-strong" /><span className="text-[10px] text-white/70">Adoption de l'IA</span></div>
        </div>
      </div>
      <div className="flex gap-2 mt-3">
        <span className="flex-1 text-center text-[11px] font-semibold border border-coral text-coral-dark rounded-md py-1.5">Citation</span>
        <span className="flex-1 text-center text-[11px] font-semibold bg-coral-soft text-coral-dark rounded-md py-1.5">Illustration IA</span>
        <span className="flex-1 text-center text-[11px] font-semibold text-slate-400 border border-slate-200 rounded-md py-1.5">Annonce</span>
      </div>
    </div>
  );
}

export function CalendarMock() {
  const days = ["L", "M", "M", "J", "V", "S", "D"];
  const posts = { 2: "9h", 4: "8h", 9: "12h", 11: "9h", 16: "8h", 18: "17h", 23: "9h" };
  return (
    <div className="p-5">
      <div className="flex items-center gap-2 mb-3 text-coral-dark"><Calendar className="h-4 w-4" /><span className="text-xs font-semibold uppercase tracking-widest">Calendrier</span></div>
      <div className="grid grid-cols-7 gap-1.5">
        {days.map((d, i) => <div key={i} className="text-center text-[10px] font-bold text-slate-400">{d}</div>)}
        {Array.from({ length: 28 }).map((_, i) => (
          <div key={i} className={`aspect-square rounded-md text-[10px] flex flex-col items-center justify-center border ${posts[i] ? "border-coral bg-coral-soft" : "border-slate-100 bg-white"}`}>
            <span className={posts[i] ? "text-coral-dark font-bold" : "text-slate-300"}>{i + 1}</span>
            {posts[i] && <span className="flex items-center gap-0.5 text-[8px] text-coral-dark"><Linkedin className="h-2 w-2" />{posts[i]}</span>}
          </div>
        ))}
      </div>
      <div className="mt-3 flex items-center gap-1.5 text-[11px] text-slate-500"><Check className="h-3.5 w-3.5 text-green-600" /> 7 posts programmés ce mois-ci</div>
    </div>
  );
}
